import {useConfirmContext,SHOW_CONFIRM,HIDE_CONFIRM} from '../context/ConfirmDialogContext'

let resolveCallback;
export default function useConfirm() {
    const [confirmState, dispatch] = useConfirmContext();
    const confirm = message => {
        dispatch({
            type: SHOW_CONFIRM,
            payload: {
                message
            }
        });
        return new Promise((resolve, reject) => {
            resolveCallback = resolve;
        });
    };
    const onConfirm = () => {
        closeConfirm();
        resolveCallback(true);
    };

    const onCancel = () => {
        closeConfirm();
        resolveCallback(false);
    };

    const closeConfirm = () => {
        dispatch({
            type: HIDE_CONFIRM
        });
    };

    return { confirm, onConfirm, onCancel, confirmState };
}